<template>
  <v-app>
    <div id="app">
      <router-view/>
    </div>
  </v-app>
</template>

<script>
import axios from 'axios'
import {mapActions, mapGetters} from "vuex";
import 'shepherd.js/dist/css/shepherd.css';
import {locale} from "devextreme/localization";

export default {
  components: {},
  computed: {
    ...mapGetters({
      AUTH: "auth/AUTH"
    })
  },
  methods: {
    ...mapActions({
      GET_NEW_TOURS: 'dataEntities/GET_NEW_TOURS',
      GET_USERS: 'dataEntities/GET_USERS',
      GET_POSTS: 'dataEntities/GET_POSTS',
      GET_REPORTS: 'dataEntities/GET_REPORTS',
      GET_ADDITIONAL_PROPS: 'dataEntities/GET_ADDITIONAL_PROPS',
      GET_ROLES: 'dataEntities/GET_ROLES',
      GET_USER_ROLE: 'auth/GET_USER_ROLE',
      GET_OPERATIONS: 'dataEntities/GET_OPERATIONS'
    }),
    setUrlSettings() {
      const url = window.location.origin + this.$router.options.base
      this.$store.commit('settings/SET_FRONTEND_URL', url)
      if (process.env.NODE_ENV === 'development') {
        this.$store.commit('settings/SET_BACKEND_URL', 'http://localhost:3001/api')
      } else {
        this.$store.commit('settings/SET_BACKEND_URL', url + 'api')
      }
      axios.defaults.baseURL = this.$store.getters['settings/BACKEND_URL']
    },
  },
  created() {
    locale(navigator.language);
    this.setUrlSettings()
    if (this.AUTH) {
      this.GET_NEW_TOURS()
      this.GET_USERS()
      this.GET_REPORTS()
      this.GET_ADDITIONAL_PROPS()
      this.GET_ROLES()
      this.GET_OPERATIONS()
      // this.GET_USER_ROLE()
    }
    //this.GET_POSTS()
  },
  watch: {
    AUTH(newVal) {
      if (newVal) {
        this.GET_REPORTS()
        this.GET_NEW_TOURS()
      }
    }
  },
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  font-family: 'Open Sans', sans-serif;
}

.bg {
  color: white;
  background: #4CAF50;
  cursor: default;
}

.shepherd-theme-custom .shepherd-button {
  background-color: #4CAF50; /* Зеленый фон */
  color: white; /* Белый текст */
  border: none;
  padding: 10px 20px;
  margin: 5px;
  cursor: pointer;
  font-size: 0.875rem;
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.0892857143em;
  text-decoration: none;
  text-indent: 0.0892857143em;
}

.shepherd-theme-custom .shepherd-button:hover {
  background-color: #45a049;
}

.shepherd-theme-custom .shepherd-content {
  background-color: #f4f4f4;
  color: #333;
  border-radius: 8px;
}

.shepherd-theme-custom .shepherd-cancel-icon {
  font-size: 50px;
  color: white !important;
  margin-top: -5px;
}

[data-popper-placement="right"].shepherd-element {
  transform: translateX(10px);
}

[data-popper-placement="right-start"].shepherd-element {
  transform: translateX(10px);
}

[data-popper-placement="left"].shepherd-element {
  transform: translateX(-10px);
}

[data-popper-placement="top"].shepherd-element {
  transform: translateY(-10px);
}

[data-popper-placement="bottom"].shepherd-element {
  transform: translateY(10px);
}

.shepherd-header {
  background: #4CAF50 !important;
  padding: 10px !important;
  margin: 0 !important;
}

.shepherd-title {
  color: white;
  font-size: 1.5rem !important;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: normal !important;
  font-family: 'Open Sans', sans-serif !important;
}

.shepherd-modal-overlay-container {
  z-index: 203 !important;
}
</style>
